var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMailFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.25 3.96A1.75 1.75 0 0 1 3 2.25h10a1.75 1.75 0 0 1 1.75 1.71L8 6.21 1.25 3.96z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.25 5.54V12c0 .966.784 1.75 1.75 1.75h10A1.75 1.75 0 0 0 14.75 12V5.54L8 7.79 1.25 5.54z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMailFilled);
export default ForwardRef;